import { Ellipsis, ExternalLink, Link2, OctagonAlert } from 'lucide-react'

import {
  Dropdown,
  DropdownEntry,
} from '~/components/component-library/Dropdown'
import { ComponentEntry } from '~/components/component-library/internal/Sidebar/types'
import {
  buildComponentIssueUrl,
  getComponentPageUrl,
} from '~/components/component-library/internal/Sidebar/utils'
import { useCopyValue } from '~/hooks/useCopyValue'

export const SidebarRowDropdown = ({ name, id }: ComponentEntry) => {
  const { handleCopy } = useCopyValue()

  const dropdownItems: DropdownEntry[] = [
    {
      content: 'Copy link',
      icon: <Link2 />,
      onClick: () => handleCopy(getComponentPageUrl(id), 'Link copied'),
    },
    {
      content: 'Open in new tab',
      icon: <ExternalLink />,
      onClick: () => window.open(getComponentPageUrl(id), '_blank'),
    },
    'divider',
    {
      content: 'Report an issue',
      icon: <OctagonAlert />,
      onClick: () => window.open(buildComponentIssueUrl(name), '_blank'),
    },
  ]

  return (
    <Dropdown side="right" align="start" items={dropdownItems}>
      <Ellipsis className="size-4 text-secondary opacity-0 transition-opacity duration-100 hover:!opacity-75 group-hover/component:opacity-100" />
    </Dropdown>
  )
}
